import { Configuration, RedirectRequest } from "@azure/msal-browser";

const tenantId = process.env.REACT_APP_TENANT_ID;
const appId = process.env.REACT_APP_APP_ID;

export const msalConfig: Configuration = {
  auth: {
    clientId: appId ?? "",
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
  },
};

export const loginRequest: RedirectRequest = {
  scopes: ["openid", "profile", `api://${appId}/access_as_user`],
};
